import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators'
import {store} from "@/store/index"

const name = 'meta';

if (store.hasModule(name)) {
    store.unregisterModule(name)
}

@Module({ dynamic: true, store, name: name })
export default class MetaModule extends VuexModule {
    version = 1
    foo = 'bam';

    @Mutation
    bumpVersion() {
        this.version++;
    }

    @Action
    async checkVersionUpdate () {
        this.bumpVersion();
        console.log(this.version, this.foo)
    }
}
